module.exports = __webpack_public_path__ + "static/img/certificate_img27.2eb08359.jpg";